<template>

<div class="v-data-table v-data-table--dense theme--light ">
  <div class="v-data-table__wrapper">
   <table class="booking-detail" v-if="booking">
     <thead class="v-data-table-header">
      <tr>
        <td>
          <div >
            Type: <span class="primary--text"> {{ type }}</span>
            <span class="black--text px-1"> {{ booking.ap_date }}</span>
            <span class="primary--text px-1"> {{ booking.ap_time }}</span>
          </div>
        </td>
        <td>price</td><td>distance</td><td>duration</td>
      </tr>
    </thead>
    <tbody>
      <tr class="grey--text px-1" v-for="(item, index) in booking[type]" :key="index">
        <td>
          <div>{{ item.trip.origin }}</div><div>{{ item.trip.destination }}</div>
        </td>
        <td>{{ item.price.text || item.price}}</td><td>{{ item.distance.text || item.distance}}</td><td>{{ item.duration.text }}</td>
      </tr>

      <tr class="result primary--text">
        <td></td>
        <td>{{ booking.totals[type].price | currency}} </td><td>{{ booking.totals[type].distance }} km</td><td>{{ toTime(booking.totals[type].duration) }}</td>
      </tr>

    </tbody>
  </table>
</div>
</div>


</template>
<script>

export default {
  props: ['booking', 'type'],
  data () {
    return {
      items: {},
      totals: {}
    }
  },
  methods: {
    reset () {
      this.distance = {};
    },
    toTime (sec) {
      var time;
      if (sec > 3600) {
        time = new Date(sec * 1000).toISOString().substr(11, 5) + ' h'
      } else {
        time = new Date(sec * 1000).toISOString().substr(14, 2) + ' mins'
      }
      return time;
    }
  }
}
</script>

<style lang="scss">
.booking-detail{
  border-collapse: collapse;

    thead tr:first-child {
        height: 24px;
        border-bottom: 1px solid rgba(0,0,0,.12);
    }

    tbody td, tbody th {
        height: 18px;
    }
    tr.result {
      height: 38px;
      td {
        font-size: 15px;
      }
    }
  }
</style>
